export default __webpack_public_path__ + "static/media/amount.8352dd53.svg";